<template>
    <section class="economy-rewards columns is-variable is-6">
        <div class="column is-6 explainer">
            <div class="reward-item">
                <h4>💰 Credits & Gold</h4>
                <p>Earn <strong>credits</strong> by playing games and voting for Gamebot daily with <code>/daily</code>. Spend them in <code>/shop</code> on cosmetics. <strong>Gold</strong> is the premium currency for exclusive items.</p>
            </div>
            <div class="reward-item">
                <h4>⭐ XP & Levels</h4>
                <p>Every game you finish earns XP. Level up your profile over time, and higher levels unlock rarer cosmetic tiers, shown as a colored border around your profile card.</p>
            </div>
            <div class="reward-item">
                <h4>🏆 Achievements</h4>
                <p>Unlock achievements for milestones, like your first win, game-specific feats, and community events. Check <code>/achievements</code> to see what's left.</p>
            </div>
            <div class="reward-item">
                <h4>📋 Daily Quests</h4>
                <p>Three quests refresh every 24 hours. Complete them for bonus XP, and check progress anytime with <code>/profile</code>.</p>
            </div>
        </div>

        <div class="column is-6">
            <Discord channel="profile" class="rewards-discord">
                <div class="discord-mockup-content">
                    <DiscordMessage
                        username="you"
                        role-color="#febaca"
                        :avatar="require('@/assets/images/mockup/person.jpeg')"
                        avatarExtension=".webp">
                        /profile
                    </DiscordMessage>
                    <DiscordMessage
                        username="Gamebot"
                        bot
                        role-color="#52d9e9"
                        :avatar="require(`@/assets/images/brand/64w/pfp.png`)"
                        avatarExtension=".webp">
                        <DiscordMessageEmbed color="#105fc5" title="you's Profile">
                            <b>Level 14</b><br>
                            <code>▓▓▓▓▓▓▓▓░░░░  2,340 / 3,000 XP</code><br>
                            <br>
                            <b>Stats</b><br>
                            🎮 <b>128</b> games played<br>
                            🏆 <b>52</b> wins<br>
                            🕹️ Favorite games: <code>Anagrams</code> · <code>Survey Says</code><br>
                            <br>
                            <b>Achievements</b><br>
                            9 / 40 unlocked<br>
                            <br>
                            <b>Daily Quests</b><br>
                            ✅ Play 3 games (+50 XP)<br>
                            ⬜ Win a game of Chess [0 / 1] (+75 XP)
                        </DiscordMessageEmbed>
                    </DiscordMessage>
                    <DiscordMessage
                        username="you"
                        role-color="#febaca"
                        :avatar="require('@/assets/images/mockup/person.jpeg')"
                        avatarExtension=".webp">
                        /daily
                    </DiscordMessage>
                    <DiscordMessage
                        username="Gamebot"
                        bot
                        role-color="#52d9e9"
                        :avatar="require(`@/assets/images/brand/64w/pfp.png`)"
                        avatarExtension=".webp">
                        <DiscordMessageEmbed color="#52d9e9">
                            You claimed <b>150 credits</b> for your <b>7-day</b> vote streak! Keep it up.
                        </DiscordMessageEmbed>
                    </DiscordMessage>
                </div>
            </Discord>
        </div>
    </section>
</template>

<style lang="scss" scoped>
.economy-rewards {
    max-width: 1000px;
    margin: 0 auto;
    text-align: left;

    .explainer {
        display: flex;
        flex-direction: column;
        justify-content: center;

        .reward-item {
            margin-bottom: 24px;
            &:last-child { margin-bottom: 0; }

            h4 {
                font-weight: bold;
                margin-bottom: 6px;
            }
            p {
                color: $gray-dark;
                font-size: 0.95rem;
                line-height: 1.5;

                code {
                    background: $gray-light;
                    border-radius: 3px;
                    padding: 1px 6px;
                }
            }
        }
    }

    .rewards-discord {
        max-width: 420px;
        margin: 0 auto;
    }
}
</style>

<script>
import Discord from '@/components/Discord/Discord.vue'
import DiscordMessage from '@/components/Discord/DiscordMessage.vue'
import DiscordMessageEmbed from '@/components/Discord/DiscordMessageEmbed.vue'

export default {
    name: 'EconomyRewards',
    components: {
        Discord,
        DiscordMessage,
        DiscordMessageEmbed,
    },
}
</script>
